module.exports = __webpack_public_path__ + "media/images/front/about/point3_img02-3f249129b05a4422eba6aa67c5c077b5.jpg";